<template>
  <div id="Products">
    <v-dialog max-width="1200" hide-overlay fullscreen persistent v-model="inwardStockDialog">
      <v-card>
        <InwardStock v-if="inwardStockDialog" @cancel="inwardStockDialog=false"></InwardStock>
      </v-card>
    </v-dialog>
    <v-container fluid class="fill-height">
      <v-card v-if="productMapped" outlined width="100%"
              style="max-height: 89.0vh; min-height: 87.5vh; overflow-y: auto; overflow-x: hidden">
        <v-row>
          <v-col cols="10">
            <h2 class="pl-3 text-h6 font-weight-regular">Products ({{ products.length }})</h2>
          </v-col>
         <!-- <v-col class="text-right">
            <v-btn @click="inwardStockDialog=true" class="primary mr-3 elevation-0">Inward Stock</v-btn>
          </v-col> -->
        </v-row>
        <v-row v-for="(product,index) in products" :key="index">
          <v-col cols="12" class="py-0">
            <v-card elevation="0" class="py-0">
              <v-card-text class="py-0">
                <v-row row wrap>
                  <v-col cols="2">
                    <div class="raj-wafer-images text-center img-div" v-if="product.image" @click="openGallery([{image: product.image}])">
                      <img width="50" class="d-block mx-auto" alt="imges not found" :src="imgWpx(product.image, 200)">
                      <v-chip label text-color="white" class="mt-3" x-small v-if="product.packageType"
                              :style="`background-color: ${packageColor[product.packageType]}`">
                        {{ product.packageType.toUpperCase() }}
                      </v-chip>
                    </div>
                    <div style="position: relative;top: calc(50% - 13px);text-align: -webkit-center;" v-else>
                      <v-icon>image</v-icon>
                    </div>
                  </v-col>
                  <v-col cols="10">
                    <v-row>
                      <v-col class="pa-0 px-1" cols="6">
                        <div>
                          <h6 class="text-subtitle-1 font-weight-bold"
                              :style="{'color': product.colorCode?product.colorCode: '#3172d0'}">
                            {{product.displayName}}</h6>
                          <p class="text-left mb-1 font-weight-medium "
                             v-if="product.boxes.stock || product.packets.stock">
                            {{ product.boxes.stock }} {{product.containerType}}es , {{ product.packets.stock }} Packets
                          </p>
                          <p v-else class="error--text">Stock Unavailable</p>
                          <p class="text-caption font-italic mb-0">{{ product.noOfPieceInBox }} Pieces in {{product.containerType}}</p>
                        </div>
                      </v-col>

                      <!-- <v-col cols="6">
                        <v-row>
                          <v-col class="pa-0" cols="3">
                            <div class="text-caption">Distributor</div>
                            <div class="text-caption">Dealer</div>
                            <div class="text-caption">Retailer</div>
                          </v-col>
                          <v-col class="pa-0" cols="3">
                            <div class="text-caption black--text">₹ {{ product.DistributorPiecePrice }}/pcs</div>
                            <div class="text-caption black--text">₹ {{ product.SubDistributorPiecePrice }}/pcs</div>
                            <div class="text-caption black--text">₹ {{ product.RetailerPiecePrice }}/pcs</div>
                          </v-col>
                          <v-col class="pa-0" cols="3">
                            <div class="text-caption black--text">₹ {{ product.DistributorBoxPrice }}/{{product.containerType}}</div>
                            <div class="text-caption black--text">₹ {{ product.SubDistributorBoxPrice }}/{{product.containerType}}</div>
                            <div class="text-caption black--text">₹ {{ product.RetailerBoxPrice }}/{{product.containerType}}</div>
                          </v-col> -->
                          <!--<v-col cols="3" class="pa-0">-->
                          <!--<p v-if="product.boxes.stock || product.packets.stock">-->
                          <!--Boxes {{ product.boxes.stock }}, Packets {{ product.packets.stock }}-->
                          <!--</p>-->
                          <!--<p v-else class="error&#45;&#45;text">Stock Unavailable</p>-->
                          <!--</v-col>-->
                        <!-- </v-row>
                      </v-col> -->

                      <v-col cols="6">
                        <v-row>
                          <!-- roles + prices (dynamic) -->
                          <v-col class="pa-0" cols="3">
                            <div
                              v-for="role in rolesToShow"
                              :key="`label-${role}`"
                              class="text-caption"
                            >
                              {{ roleMap[role].label }}
                            </div>
                          </v-col>

                          <!-- /pcs prices -->
                          <v-col class="pa-0" cols="3">
                            <div
                              v-for="role in rolesToShow"
                              :key="`pcs-${role}`"
                              class="text-caption black--text"
                            >
                              ₹ {{ product[roleMap[role].piece] == null ? '-' : product[roleMap[role].piece] }}/pcs
                            </div>
                          </v-col>

                          <!-- /box prices -->
                          <v-col class="pa-0" cols="3">
                            <div
                              v-for="role in rolesToShow"
                              :key="`box-${role}`"
                              class="text-caption black--text"
                            >
                              ₹ {{ product[roleMap[role].box] == null ? '-' : product[roleMap[role].box] }}/{{ product.containerType }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="py-0" cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <gallery id="gallery-products" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
  </div>
</template>

<script>
import { IDS } from '@/Constants/IDS'
import { SUBSCRIBE_ALL_PRODUCTS_WITH_PRICES } from '../../graphql/subscriptions/Products'
import { SUBSCRIBE_ORGANIZATION_STOCK_BY_ID } from '../../graphql/subscriptions/OrganizationStock'
import InwardStock from '@/views/InwardStock/InwardStock'
import gallery from '../../mixins/gallery';
export default {
  name: 'Products',
  components: { InwardStock },
  mixins: [gallery],
  data () {
    return {
      loading: { product: true, stock: true },
      products: [], organizationStock: [],
      productMapped: false, inwardStockDialog: false,
      loggedInUser: JSON.parse(localStorage.user),
      packageColor: JSON.parse(localStorage.packageColor),
    }
  },
  computed: {
    userType () {
      // return (this.loggedInUser?.userType?.name || '').toLowerCase();
      const OrganizationType = this.loggedInUser?.organization?.type;

      let type = '';
      if (IDS.organizationTypes.Distributor === OrganizationType) {
        type = 'distributor';
      } else if (IDS.organizationTypes.Dealer === OrganizationType) {
        type = 'dealer';
      } else if (IDS.organizationTypes.Retailer === OrganizationType) {
         type = 'retailer';
      }
      return type;
    },
    // map logical roles to product field names
    roleMap () {
      return {
        distributor: {
          label: 'Distributor',
          piece: 'DistributorPiecePrice',
          box:   'DistributorBoxPrice',
        },
        dealer: {
          label: 'Dealer',
          // your product fields use "SubDistributor" for dealer
          piece: 'SubDistributorPiecePrice',
          box:   'SubDistributorBoxPrice',
        },
        retailer: {
          label: 'Retailer',
          piece: 'RetailerPiecePrice',
          box:   'RetailerBoxPrice',
        },
      };
    },
    // select which roles to show based on user type
    rolesToShow () {
      if (this.userType === 'distributor') {
        // show all
        return ['distributor', 'dealer', 'retailer'];
      }
      if (this.userType === 'dealer') {
        // dealer + retailer
        return ['dealer', 'retailer'];
      }
      if (this.userType === 'retailer') {
        // only retailer
        return ['retailer'];
      }
      // fallback (if some unexpected type)
      return ['retailer'];
      // return ['distributor', 'dealer', 'retailer'];
    },
  },

  apollo: {
    $subscribe: {
      Products: {
        query: SUBSCRIBE_ALL_PRODUCTS_WITH_PRICES, fetchPolicy: 'network-only',
        result ({ data, loading }) {
          if (!loading) {
            this.products = data.Products
            this.loading.product = false
            this.mapProductPrices()
          }
        },
      },
      OrganizationStock: {
        query: SUBSCRIBE_ORGANIZATION_STOCK_BY_ID, fetchPolicy: 'network-only',
        skip () { return (!this.loggedInUser || !this.products.length) && this.isProductSearched},
        variables () { return { id: this.loggedInUser.organizationId } },
        result ({ data, loading }) {
          if (!loading) {
            this.organizationStock = data.OrganizationStock
            this.loading.stock = false
            this.mapProductStocks()
          }
        },
      },
    },
  },
  methods: {
    mapProductPrices () {
      this.products.forEach(product => {
        product.ProductPrices.forEach(productPrice => {
          if (productPrice.unitId === IDS.unitType.Box && productPrice.priceListId ===
              IDS.userPriceList.DistributorSurat)
            product['DistributorBoxPrice'] = productPrice.price
          else if (productPrice.unitId === IDS.unitType.Box && productPrice.priceListId ===
              IDS.userPriceList.DealerSurat)
            product['SubDistributorBoxPrice'] = productPrice.price
          else if (productPrice.unitId === IDS.unitType.Box && productPrice.priceListId ===
              IDS.userPriceList.RetailerSurat)
            product['RetailerBoxPrice'] = productPrice.price
          else if (productPrice.unitId === IDS.unitType.Piece && productPrice.priceListId ===
              IDS.userPriceList.DistributorSurat)
            product['DistributorPiecePrice'] = productPrice.price
          else if (productPrice.unitId === IDS.unitType.Piece && productPrice.priceListId ===
              IDS.userPriceList.DealerSurat)
            product['SubDistributorPiecePrice'] = productPrice.price
          else if (productPrice.unitId === IDS.unitType.Piece && productPrice.priceListId ===
              IDS.userPriceList.RetailerSurat)
            product['RetailerPiecePrice'] = productPrice.price
        })
      })
    },
    mapProductStocks () {
      if (this.loading.product === false && this.loading.stock === false) {
        this.products.forEach(product => {
          product.packets = { quantity: 0, stock: 0, unitId: IDS.unitType.Piece }
          product.boxes = { quantity: 0, stock: 0, unitId: IDS.unitType.Box }
        })
        let pStockObj = {};             //org stock productId.unitId (when we need to open box)
        this.organizationStock.forEach(s => {
          if(!pStockObj[s.productId])
            pStockObj[s.productId] = {[IDS.unitType.Box]:{quantity:0, reservedQuantity:0}, [IDS.unitType.Piece]:{quantity:0, reservedQuantity:0}};
          pStockObj[s.productId][s.unitId] = {quantity: s.quantity, reservedQuantity: s.reservedQuantity};
        })

        this.products.forEach(product => {
          if(pStockObj[product.id]) {
            let availablePiece = pStockObj[product.id][IDS.unitType.Piece].quantity - pStockObj[product.id][IDS.unitType.Piece].reservedQuantity;
            let availableBox = pStockObj[product.id][IDS.unitType.Box].quantity - pStockObj[product.id][IDS.unitType.Box].reservedQuantity;
            if(availablePiece<0 && availableBox>0) {
              product.boxes.stock = availableBox - 1;
              product.packets.stock = product['noOfPieceInBox'] + availablePiece;
            } else {
              product.boxes.stock = availableBox;
              product.packets.stock = availablePiece;
            }
          }
          this.$forceUpdate()
        })
        this.$forceUpdate()
        this.productMapped = true
      }
    },
  },
}
</script>

<style scoped>
/*.raj-wafer-card {*/
/*border-radius: 4px;*/
/*background-color: #ffffff !important;*/
/*box-shadow: 0 2px 6px rgba(195, 195, 195, 0.5) !important;*/
/*margin: 3px 6px;*/
/*}*/

/*.raj-wafer-images img {*/
/*position: relative;*/
/*top: calc(50% - 30px);*/
/*}*/

.pieces-label {
  color: darkgray;
  font-size: 14px;
  margin: 2px 0px;
}

.PartyPack {
  background-color: #EC2144 !important;
}

.FamilyPack {
  background-color: #DAB44F !important;
}

.CouplePack {
  background-color: #45B1E6 !important;
}
.img-div{
  cursor: pointer;
}
</style>
